import { Injectable } from '@angular/core';
import { API } from './api';
import { UserProvider } from './user';
import { BaseProvider } from './base';
import bugsnag, { Bugsnag } from 'bugsnag-js';
import { OnPremiseProvider } from './on-premise';

let bugsnagClient: Bugsnag.Client | null = null;
@Injectable()
export class BugsnagProvider extends BaseProvider {
    constructor(private userProvider: UserProvider, private api: API, private onPremiseProvider: OnPremiseProvider) {
        super();

        if (!this.onPremiseProvider.isOnPremiseElectronApp()) {
            bugsnagClient = bugsnag({
                apiKey: '3d71819272146b851d8637ce1a37a39a',
                releaseStage: this.api.getEnvironment()
            });

            bugsnagClient.user = {
                email: this.userProvider.getUserInformation().email,
                token: this.api.getWheatleyToken()
            };
        }
    }

    /**
     * Helper function to expose the bugsnag.notify() functionality
     * @see https://docs.bugsnag.com/platforms/javascript/reporting-handled-errors/
     *
     * @param payload the error object we're sending to bugsnag
     * @param opts (optional) any additional parameters that need to be passed to bugsnag
     *
     * @return void
     */
    logError(payload: any, opts = {}): void {
        if (bugsnagClient && !this.onPremiseProvider.isOnPremiseElectronApp()) {
            try {
                bugsnagClient.notify(payload, opts);
            } catch (e) {
                console.log('Could not contact BugSnag services:', e);
            }
        }
    }

    /**
     * Helper function to log to bugsnag at an info level
     *
     * @param payload the info object we're logging to bugsnag
     *
     * @return void
     */
    logInfo(payload: any): void {
        if (bugsnagClient && !this.onPremiseProvider.isOnPremiseElectronApp()) {
            try {
                bugsnagClient.notify(`INFO: ${payload}`, { severity: 'info' });
                console.log(payload);
            } catch (e) {
                console.log('Could not contact BugSnag services:', e);
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/providers/bugsnag.ts